export enum EAddMachineStep {
  OperationalInfo = 'OperationalInfo',
  VehicleSpecifications = 'VehicleSpecifications',
  InsuranceInfo = 'InsuranceInfo',
  // ConfirmMachine = 'ConfirmMachine',
}
